import BankViewDto from "../../../../../../consumer/bank/dto/BankViewDto";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";


export default class BankinstitutValidator implements InputValidatorI {

    private bank?: BankViewDto;

    constructor(newBank?: BankViewDto) {
        this.bank = newBank;
    }


    // *****************
    // Validator
    // ********************
    validate(): InputValidationStateBo {
        if (this.bank === undefined) {
            return InputValidationStateBo.createInValid("Das Bankinstitut konnte nicht ermittelt werden.")
        }

        if (this.bank?.name === undefined) {
            return InputValidationStateBo.createInValid("Das Bankinstitut konnte nicht ermittelt werden.")
        }


        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

}